import { normalisePhoneUK } from '@cls/shared';

export function waLink(phone: string | null | undefined, message: string): string {
  if (!phone) return '#';
  const intl = normalisePhoneUK(phone);
  if (!intl) return '#';
  return `https://wa.me/${intl}?text=${encodeURIComponent(message)}`;
}

export function openWaStaggered(items: { phone: string; message: string }[], stagger = 600): number {
  let opened = 0;
  items.forEach((it, i) => {
    if (!it.phone) return;
    setTimeout(() => window.open(waLink(it.phone, it.message), '_blank'), i * stagger);
    opened++;
  });
  return opened;
}

export function extractPhoneFromText(s: string | null | undefined): { name: string; phone: string | null } {
  if (!s) return { name: '', phone: null };
  const m = s.match(/(?:\+44\s?|0)(?:\d\s?){9,10}\d/);
  if (!m) return { name: s.trim(), phone: null };
  const phone = m[0].trim();
  const name = s.replace(phone, '').replace(/[,;]+$/, '').trim();
  return { name, phone };
}
